import { FaqSection } from '@saatva-bits/pattern-library.modules.faq'
import { CLASSIC_STARTER_BUNDLE, SAATVA_CLASSIC } from '@/constants/product-codes'
import ProductOverviewAccordion from '@/components/ProductOverviewAccordion'
import { CONTRAST1 } from '@/components/ProductOverview/ProductOverviewThemes'
import SupportValueProps from '@/components/SupportValueProps'
import ImageByContent from '@/components/ImageByContent'
import CrossSells from '@/components/CrossSells'
import VideoByContent from '@/components/VideoByContent/VideoByContent'
import PDPReviews from '@/components/PDPReviews'

const ClassicStarterBundle = () => {
    const productCode = CLASSIC_STARTER_BUNDLE

    return (
        <>
            <ProductOverviewAccordion theme={CONTRAST1} />
            <VideoByContent
                videoSide='left'
                productCode={`${productCode}--comfort-level`}
                backgroundColorClass='u-bgColor--white'
            />
            <ImageByContent
                productCode={`${productCode}--your-best-sleep`}
                sectionName='yourBestSleep'
                backgroundColorClass='u-bgColor--contrast1'
                imageSide='right'
            />
            <FaqSection />
            <PDPReviews productCode={SAATVA_CLASSIC}/>
            <CrossSells />
            <SupportValueProps />
        </>
            
    )
}

export default ClassicStarterBundle
